module.exports = __webpack_public_path__ + "static/media/image_45.b48f45ba.png";